"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DashboardController_1 = require("./DashboardController");
exports.DashboardController = DashboardController_1.DashboardController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/controllers/index.ts
// module id = 473
// module chunks = 0